export function getBaseUrl(): string {
  let url: string = document.head.getElementsByTagName('base')[0]?.attributes.getNamedItem('href').value || '';

  if (url.endsWith('/')) {
    url = url.slice(0, -1);
  }

  return url;
}
